<template>
    <div class="labels">
        <div v-if="!showIsBoundOnly"
            :class="['labels__date', `labels__date--${poll.status}`]"
        >
            <i class="icon icon-calendar" />

            <span v-if="showText"
                class="labels__date-text"
            >
                {{ $t(dateText) }}
            </span>

            {{ date }}
        </div>

        <div v-if="poll.isBound"
            :class="['labels__icon', { 'labels__icon--with-text': showText }]"
        >
            <i class="icon icon-binding" />

            <span v-if="showText"
                class="labels__icon-text"
            >
                {{ isBoundText }}
            </span>
        </div>

        <div v-if="isCappedLimit && !showIsBoundOnly"
            :class="['labels__icon', { 'labels__icon--with-text': showText }]"
        >
            <i class="icon icon-cap" />

            <span v-if="showText"
                class="labels__icon-text"
            >
                {{ $t('global.poll.cappedLimit', { limit: poll.tokenLimit }) }}
            </span>
        </div>
    </div>
</template>

<script>
import {
    format,
} from '@shared/utils/dates';

export default {
    name: 'poll-labels',
    props: {
        poll: {
            type: Object,
            default: () => ({}),
        },
        showIsBoundOnly: {
            type: Boolean,
            default: false,
        },
        showText: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        date() {
            const date = this.poll.status === 'scheduled'
                ? this.poll.openAt
                : this.poll.closeAt;

            return date.includes('/')
                ? date
                : format(date, 'dateShort');
        },
        dateText() {
            switch (this.poll.status) {
                case 'closed':
                case 'closed-pending':
                case 'closed-blockchain-pending':
                case 'closed-release-wallet-limit':
                case 'expired':
                    return 'global.poll.expiredOn';
                case 'scheduled':
                    return 'global.poll.availableOn';
                case 'opened':
                    return 'global.poll.expiresOn';
                default:
                    return '';
            }
        },
        isBoundText() {
            return this.showIsBoundOnly
                ? `${this.$t('global.poll.binding')} - ${this.$t('pollDetails.bindingPoll')}`
                : this.$t('global.poll.binding');
        },
        isCappedLimit() {
            return this.poll.currencyId && this.poll.tokenLimit > 0;
        },
    },
};
</script>

<style lang="scss" scoped>
.labels {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 2rem;
    font-size: 1rem;

    &__date,
    &__icon {
        margin-bottom: 0.5rem;
        border-radius: 0.4rem;
        min-height: 2.25rem;
        display: flex;
        align-items: center;

        & + .labels__date,
        & + .labels__icon {
            margin-left: 0.8rem;
        }
    }

    &__date {
        color: $white-color;
        font-weight: bold;
        padding: 0 0.5rem;

        &--closed,
        &--closed-pending,
        &--closed-blockchain-pending,
        &--closed-release-wallet-limit,
        &--expired {
            background-color: $monza-color;
        }

        &--scheduled {
            background-color: $gorse-color;
            color: $black-color;
        }

        &--opened {
            background-color: $lima-color;
        }

        &-text {
            margin-right: 0.25rem;
            font-weight: bold;
        }

        .icon {
            margin-right: 0.5rem;
        }
    }

    &__icon {
        color: $white-color;
        background: $indigo-color;
        width: 2.25rem;
        display: flex;
        align-items: center;
        justify-content: center;

        &--with-text {
            width: auto;
            padding: 0 0.5rem;
        }

        &-text {
            font-weight: bold;
            margin-left: 0.5rem;
            line-height: 1;
            padding: 0.5rem 0;
        }
    }

    .icon {
        font-size: 1.4rem;
    }
}
</style>